// extracted by mini-css-extract-plugin
export default {"odometer":"Odometer_odometer__ii31J","stepper":"Odometer_stepper__Fzk94"};